import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2025 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useEffect, forwardRef, useState, useRef } from "react";
import { Icon, SourceTag, EntityMetaToolTip, TsDataSource } from "../index";
import { normaliseCaps } from "../general/utils";
import DraggableList from "react-draggable-list";
const TRANSITION_TIME = 300;
function SelectedAttributesContainer(props) {
    const { baseUrl, endpoint, attributes, setAttributes, title = "Active Columns:", } = props;
    const [recentlyMoved, setRecentlyMoved] = useState(null);
    const [deletingIndex, setDeletingIndex] = useState(null);
    const [objectAttributes, setObjectAttributes] = useState({});
    const ref = useRef(null);
    useEffect(() => {
        const ds = new TsDataSource({ baseUrl: baseUrl });
        ds.getEntityMeta().then((meta) => {
            setObjectAttributes(meta.flatAttributes[endpoint]);
        });
    }, []);
    const moveAttributeUp = (index) => {
        if (index === 0)
            return;
        const newAttributes = [...attributes];
        [newAttributes[index - 1], newAttributes[index]] = [
            newAttributes[index],
            newAttributes[index - 1],
        ];
        setAttributes(newAttributes);
        setRecentlyMoved(index - 1);
        setTimeout(() => setRecentlyMoved(null), TRANSITION_TIME);
    };
    const moveAttributeDown = (index) => {
        if (index === attributes.length - 1)
            return;
        const newAttributes = [...attributes];
        [newAttributes[index + 1], newAttributes[index]] = [
            newAttributes[index],
            newAttributes[index + 1],
        ];
        setAttributes(newAttributes);
        setRecentlyMoved(index + 1);
        setTimeout(() => setRecentlyMoved(null), TRANSITION_TIME);
    };
    const removeAttribute = (index) => {
        setDeletingIndex(index);
        setAttributes(attributes.filter((_, i) => i !== index));
        setDeletingIndex(null);
    };
    const SelectedColumn = forwardRef(({ item, dragHandleProps }, ref) => {
        const attr_name = item;
        const attributeDeatils = objectAttributes[attr_name] || {};
        const index = attributes.indexOf(attr_name);
        return (_jsxs("div", { ref: ref, className: `tol-config-drawer-selected-column ${recentlyMoved === index ? "highlight" : ""} ${deletingIndex === index ? "deleting" : ""}`, children: [_jsxs("div", { children: [_jsx("span", { ...dragHandleProps, children: _jsxs("div", { className: "tol-config-drawer-selected-column-name", children: [_jsx("div", { style: { display: 'inline', paddingRight: '5px' }, children: attributeDeatils.display_name || normaliseCaps(attr_name) }), _jsx(EntityMetaToolTip, { baseUrl: baseUrl, endpoint: endpoint, field: attr_name })] }) }), _jsx("p", { className: "tol-config-drawer-selected-column-key", children: attr_name })] }), _jsxs("div", { className: "tol-config-drawer-btn-array", children: [attributeDeatils.source && _jsx(SourceTag, { source: attributeDeatils.source }), _jsx("div", { className: "tol-active-column-btn first", onClick: () => moveAttributeUp(index), children: _jsx(Icon, { icon: "arrow-up", size: "lg" }) }), _jsx("div", { className: "tol-active-column-btn", onClick: () => moveAttributeDown(index), children: _jsx(Icon, { icon: "arrow-down", size: "lg" }) }), _jsx("div", { className: "tol-active-column-btn delete", onClick: () => removeAttribute(index), children: _jsx(Icon, { icon: "close", size: "lg" }) })] })] }, `${attr_name}-${index}`));
    });
    return (_jsx("div", { children: _jsxs("div", { children: [_jsx("h6", { className: "tol-config-drawer-column-title", children: title }), _jsx("div", { className: "tol-config-drawer-column-container", ref: ref, children: _jsx(DraggableList, { container: () => ref.current, itemKey: (item) => item, list: attributes, 
                        // @ts-ignore
                        template: (props) => (_jsx(SelectedColumn, { ...props })), onMoveEnd: (newList) => (setAttributes(newList)), springConfig: { stiffness: 500, damping: 100 } }) }), attributes.length === 0 && (_jsx("p", { children: _jsx("i", { children: "No active columns. Select columns to display..." }) }))] }) }));
}
export default SelectedAttributesContainer;
